import { transformToHtml } from '../../utils/CommonUtils';
import { footerDomDT, footerIntlDT } from '../../utils/htmlUtil/htmlFooterDT';

const FooterDistanceDT = (props) => {
  const { footer_data: footer, isIntl } = props?.data || {};
  let footerData = footer ? footer : '';
  if (footerData === '' && isIntl) {
    footerData = footerIntlDT;
  } else if (footerData === '') {
    footerData = footerDomDT;
  }
  return (
    <>
      <div id="footer_block">{ transformToHtml(footerData)}</div>
    </>
  );
};

export default FooterDistanceDT;